import {
  GET_ALLOCATION_REPORT_REQUEST,
  GET_ALLOCATION_REPORT_SUCCESS,
  GET_ALLOCATION_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const GetallocationReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_ALLOCATION_REPORT_REQUEST });
  const newData = {
    sku: values.sku === undefined ? null : values.sku,
    order_header_no: values.order_header === undefined ? null : values.order_header,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/AllocationReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_ALLOCATION_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ALLOCATION_REPORT_ERROR,
        payload: [],
      });
    });
};
